import { render, staticRenderFns } from "./CLAPolicySummary.vue?vue&type=template&id=127c168c&scoped=true"
import script from "./CLAPolicySummary.vue?vue&type=script&lang=js"
export * from "./CLAPolicySummary.vue?vue&type=script&lang=js"
import style0 from "./CLAPolicySummary.vue?vue&type=style&index=0&id=127c168c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c168c",
  null
  
)

export default component.exports